var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13v13H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.438 13A2.438 2.438 0 0 1 0 10.562V8.938a.813.813 0 1 1 1.625 0v1.624a.816.816 0 0 0 .813.814h6.5a.817.817 0 0 0 .815-.814V8.938a.811.811 0 1 1 1.622 0v1.624A2.437 2.437 0 0 1 8.938 13zm2.676-4.3L1.866 5.447A.811.811 0 0 1 3.014 4.3l1.863 1.863V.814a.814.814 0 1 1 1.623 0v5.349L8.366 4.3a.813.813 0 0 1 1.148 1.151L6.261 8.7a.8.8 0 0 1-.571.24.809.809 0 0 1-.576-.24z",
    fill: "currentColor",
    transform: "translate(.813)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.29414375419989d60ef72237ef77698c.svg";
export { ForwardRef as ReactComponent };